module.exports = __webpack_public_path__ + "img/logo.cd49fe3f.png";